import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const branchUserTypes = {
    customer: "customer",
    retailer: "retailer",
}

export const targetTypes = {
    customer: "customer",
    retailer: "retailer",
}

export function useBranchUsers({
    branchUserType: _branchUserType, 
    targetType: _targetType
}) {

    const [branchUserType, setBranchUserType] = useState(_branchUserType);
    const [targetType, setTargetType] = useState(_targetType);

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint1 = "user/branch_user";
    const endpoint2 = "user/branch_users"

    const list = async (props) => {

        setIsLoading(true);

        try {

            let url = getListsUrl(`${endpoint2}`, props);

            if (branchUserType) {
                url = getListsUrl(`${endpoint2}/${branchUserType}`, props);
            }

            if (props.branchUserType) {
                url = getListsUrl(`${endpoint2}/${props.branchUserType}`, props);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const create = async ({ data }) => {

        setIsLoading(true)
        try {

            const url = endpoint1;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint1}/${id}`

            const postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids, branchUserType: overrideBranchUserType }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            let url = `${endpoint2}/delete`

            // let url = `${endpoint2}/${branchUserType}/delete`

            if (overrideBranchUserType) {
                url = `${endpoint2}/${overrideBranchUserType}/delete`
            }

            const postData = {
                scope: {
                    // target: targetType
                    target: branchUserType
                },
                payload: {
                    ids
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id }) => {

        setIsLoading(true);

        try {

            let url = `${endpoint1}/${id}`;

            if (branchUserType) {
                url = `${endpoint1}/${branchUserType}/${id}`;
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;
        }


    }

    return {
        isLoading,
        filterOperatorTypes,
        branchUserTypes,
        list,
        get,
        create,
        update,
        remove
    }
}